
// import img from '../../assets/logo/minas_log.jpeg';

// import img from '../../../assets/logo/FullLogo_NoBuffer.jpg';

const Footer = () => {
    return (
       <>
  <footer className="bg-black text-white py-8">
      <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center">
        
        {/* Left Section: Branding / Logo */}
        <div className="mb-4 md:mb-0">
        <a href="https://www.instagram.com/mjpixelvibe">  <h2 className="text-xl font-bold uppercase"> print on demand </h2></a>
          <p className="text-gray-400 text-sm">Showcasing print-on-demand designs</p>
        </div>

        {/* Middle Section: Links */}
        <div className="flex space-x-6 mb-4 md:mb-0">
          <a href="##Skills" className="hover:text-gray-300 transition">Skills</a>
          <a href="https://github.com/sharifulislm" className="hover:text-gray-300 transition">Portfolio</a>
          <a href="#contact" className="hover:text-gray-300 transition">Contact</a>
        </div>

        {/* Right Section: Social / Contact */}
        <div className="flex space-x-4">
          <a
            href="https://www.linkedin.com/in/sharifulislm/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-gray-300 transition"
          >
            Instagram
          </a>
       <a
  href="https://wa.me/+96551494820"
  target="_blank"
  rel="noopener noreferrer"
  className="hover:text-gray-300 transition"
>
  WhatsApp
</a>
        </div>
      </div>

      {/* Bottom copyright */}
      <div className="text-center text-gray-500 text-sm mt-6">
      <a href="https://github.com/sharifulislm">  © </a>{new Date().getFullYear()}  Print on Demand. All rights reserved.
      </div>
    </footer>
       </>
    );
};

export default Footer;
// import React from 'react';
// import { AiFillLinkedin, AiOutlineMail, AiOutlineTwitter } from "react-icons/ai";

// import { BsFacebook, BsGithub, BsWhatsapp } from "react-icons/bs";
// import { Link } from 'react-router-dom';
// // import img from '../../../assets/logo/FullLogo_NoBuffer.jpg';

// const Footer = () => {
//     return (
//        <>
//        <footer id='footers' class="footer p-10 bg-black text-white">
  

//   <div className='m-auto'>
//   <a href="https://www.linkedin.com/in/sharifulislm/?fbclid=IwAR26GK7V66g2pHPsxf65JHItfEFwQuHoNv7Ndj9xHwXsijO8rY4WzmgrLHs" target="_blank" rel="noreferrer" style={{color:"white"}} className="btn logostyles btn-ghost normal-case text-xl">Shariful</a>
//   <div class=" flex">
//  <a className='text-white text-3xl p-2 rounded' href="https://www.facebook.com/shariful.islam.fb" target="_blank" rel="noreferrer"> <span className='text-white text-3xl p-2 rounded'>  <BsFacebook ></BsFacebook></span>  </a>
//     <a className='text-white text-3xl p-2 rounded' href="https://www.linkedin.com/in/sharifulislm/?fbclid=IwAR26GK7V66g2pHPsxf65JHItfEFwQuHoNv7Ndj9xHwXsijO8rY4WzmgrLHs" target="_blank" rel="noreferrer">  <span className='text-white text-3xl w-12 p-2 rounded'> <AiFillLinkedin></AiFillLinkedin> </span>  </a> 
//       <a className='text-white text-3xl p-2 rounded' href="https://github.com/sharifulislm" target="_blank" rel="noreferrer"> <span className='text-white text-3xl w-12 p-2 rounded'>  <BsGithub ></BsGithub></span> </a>
//   </div>
//   </div> 
//   <div className='text-left m-auto text-white'>
//   <span class=" text-center  text-white">Contact info </span> 
// <ul className='text-white'>

// <li ><Link className='text-white' to="/">sharif.hossain.p87@gmail.com</Link></li>
// <li><Link className='text-white' to="/Service">+96551494820</Link></li>
//  <li><Link className='text-white' to="/AllReveiw">Kuwait ,Mahboula (BLOCK-1)</Link></li>
// </ul>

//   </div> 
//   <div className='m-auto '>
//     <span class=" text-white ">Social</span> 
//     <div class=" flex">
//  <a className='text-white text-3xl p-2 rounded' href="https://api.whatsapp.com/send?phone+96551494820" target="_blank" rel="noreferrer"> <span className='text-white text-3xl p-2 rounded'>  <BsWhatsapp></BsWhatsapp></span>  </a>
//     <a className='text-white text-3xl p-2 rounded' href="mailto:sharif.hossain.p87@gmail.com " target="_blank" rel="noreferrer">  <span className='text-white text-3xl w-12 p-2 rounded'> <AiOutlineMail></AiOutlineMail> </span>  </a> 
//     <a className='text-white text-3xl p-2 rounded' href="https://twitter.com/sharif26630" target="_blank" rel="noreferrer">  <span className='text-white text-3xl w-12 p-2 rounded'> <AiOutlineTwitter></AiOutlineTwitter> </span>  </a> 
//   </div>
//   </div>
//   <div className='text-left invisible  md:visible '>

// <ul className=''>
// <li className='mb-2'><Link className='text-white' to="/">HOME</Link></li>
// <li className='mb-2'><Link className='text-white' to="/Service">PROJECTS</Link></li>
//  <li className='mb-2'><Link className='text-white' to="/AllReveiw">BLOG</Link></li>
//  <li className='mb-2'><Link className='text-white' to="/ABOUT">ABOUT</Link></li>

// </ul>

//   </div> 
// </footer>
//        </>
//     );
// };

// export default Footer;